import { useState, useEffect } from 'react';
import axios from 'axios';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

const COLORS = ['#09090B', '#3f3f46', '#2563eb', '#0891b2', '#d97706', '#16a34a', '#dc2626'];

export const DaywiseStageChart = () => {
  const [chart, setChart] = useState({ stages: [], data: [] });

  useEffect(() => {
    axios.get('/api/dashboard/daywise-stage?days=14', { withCredentials: true })
      .then(({ data }) => setChart(data))
      .catch(() => {});
  }, []);

  const hasData = chart.data.some(d => chart.stages.some(s => d[s] > 0));

  return (
    <div className="bg-white border border-zinc-200 p-4 mb-6" data-testid="chart-daywise-stage">
      <div className="flex items-baseline justify-between mb-3">
        <h3 className="font-heading font-bold text-base text-[#09090B]">Pairs Produced per Day — Stage-wise</h3>
        <span className="text-[10px] uppercase tracking-wider text-zinc-500">Last 14 days</span>
      </div>
      {hasData ? (
        <div className="h-72">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={chart.data} barGap={1}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey="label" tick={{ fontSize: 10 }} />
              <YAxis tick={{ fontSize: 10 }} allowDecimals={false} />
              <Tooltip labelFormatter={(l, p) => p?.[0]?.payload?.date || l} itemSorter={(it) => chart.stages.indexOf(it.dataKey)} />
              <Legend wrapperStyle={{ fontSize: 11 }} itemSorter={(it) => chart.stages.indexOf(it.dataKey)} />
              {chart.stages.map((s, i) => (
                <Bar key={s} dataKey={s} fill={COLORS[i % COLORS.length]} radius={[2, 2, 0, 0]} />
              ))}
            </BarChart>
          </ResponsiveContainer>
        </div>
      ) : (
        <div className="h-32 flex items-center justify-center text-sm text-zinc-400" data-testid="chart-daywise-stage-empty">
          No production entries in the last 14 days
        </div>
      )}
    </div>
  );
};
